import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

import { cn } from "@/lib/utils";

const sizeClasses = {
  xs: "h-3.5 w-6",
  sm: "h-4 w-7",
  md: "h-5 w-9",
};

const thumbSizeClasses = {
  xs: "h-2.5 w-2.5",
  sm: "h-3 w-3",
  md: "h-4 w-4",
};

export interface CustomSwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  size?: "xs" | "sm" | "md";
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  CustomSwitchProps
>(({ className, size = "md", ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      `
      /* Layout */
      peer
      inline-flex

      shrink-0
      items-center

      /* Styling */
      rounded-full
      border-2
      border-transparent
      shadow-sm
      transition-colors
      bg-bg+2

      /* Interactions */
      cursor-pointer
      focus-visible:outline-none
      focus-visible:ring-2
      focus-visible:ring-ring
      focus-visible:ring-offset-2
      focus-visible:ring-offset-background

      /* Disabled States */
      disabled:cursor-not-allowed
      disabled:opacity-50

      /* State-Based Styles */
      data-[state=checked]:bg-ac
      data-[state=unchecked]:bg-bg+2



    `,
      sizeClasses[size],
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        `pointer-events-none 
        block 
        rounded-full 
        bg-white 
        shadow-lg 
        ring-0 
        transition-transform 
        data-[state=checked]:translate-x-full 
        data-[state=unchecked]:translate-x-0   
       
        `,
        thumbSizeClasses[size]
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
